<template>
  <div id="settings-profile">
    <h1 class="title is-2">{{ $t('sidebar.account') }}</h1>
    <div class="card my-2">
        <div class="card-content">
          <p>
            <span class="is-size-5 has-text-weight-semibold"
              style="white-space: pre-wrap">{{ $t('DashboardSettings.account') }}: </span>
            <span>{{ place.email }}</span>
          </p>
          <p>
            <br>
            <span style="font-weight:600; white-space: pre-wrap">{{ $t('DashboardSettings.currentPlan') }}: </span>
            <span v-if="hasActiveSubscription">{{ $t('DashboardSettings.standard') }}</span>
            <span v-else-if="place.subscription.isTrial">{{ $t('DashboardSettings.trial') }} {{ $t('DashboardSettings.till') }} {{place.subscription.activeTill.split("T")[0]}}</span>
            <span v-else>{{ $t('DashboardSettings.no') }}</span>
          </p>
          <!-- <p v-if="place.isTrial=='true'">
              <span style="font-weight:600">{{ $t('DashboardSettings.trial') }}</span>
              <span>{{ formatDate(place.trialEndDate) }}</span>
            </p> -->
          <p>
            <br>
          </p>
          <!-- <a
              href="#"
              v-if="planName() == $t('DashboardSettings.pro')"
              @click.prevent="displayPayBlock=!displayPayBlock"
            >
              {{ $t('DashboardSettings.changePlan') }}
            </a> -->
          <div v-if="place.subscription.isTrial=='true' || place.subscription.isTrial==true">
            <router-link class="button upgrade" tag="a" to="/payment">{{ $t('DashboardSettings.upgrade') }}</router-link>
            <!-- <router-link v-else class="button upgrade" tag="a" to="/payment_ru">{{ $t('DashboardSettings.upgrade') }}</router-link> -->
            
          </div>
          <!-- <div v-bind:class="{'invisible':!displayPayBlock}">
              <p v-if="planName() == $t('DashboardSettings.pro')" style="margin-top:1rem;">
                {{ $t('DashboardSettings.cancelPlanMsg') }}
              </p>
            </div> -->
        </div>
      </div>
  </div>

</template>

<script>
        
import _ from "underscore";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SettingsProfile",
  components: {
   
  },
  props: [],
  computed: _.extend(
    {
      hasActiveSubscription() {
        if (!this.place.subscription || !this.place.subscription.activeTill) return true
        let now = new Date()
        let activeTill = new Date(this.place.subscription.activeTill)
        var difference_In_Time = activeTill.getTime() - now.getTime();
        var difference_In_Days = Math.ceil(difference_In_Time / (1000 * 3600 * 24));
        if (difference_In_Days >= 0)
          return true
          else return false
      }
    },
    mapGetters({
    place: "getPlaceInfo"
  })
  ),

  data() {
    return {}
  },
  
  methods: _.extend({}, mapActions(["updatePlaceInfo"]), {
    saveInfo() {
      this.$ma.trackEvent({category: 'event', action: 'Profile updated', label : null, value : null})
      this.updatePlaceInfo(this.place).then(() => {
        this.$buefy.toast.open(this.$buefy.toast.open(this.$t('DashboardTable.saved')))
      });
    }
    }),
  mounted() {

  }
};
</script>
